import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@material-ui/core';
import { TableHeaderCell } from 'core';
import { dateFormatter } from 'core/helpers/formatters';
import { ElemType, MapClassesToElem } from 'core/helpers/styles-helpers';
import Checkbox from 'core/components/checkbox';
import { theme } from 'core/components/theme/theme';

import { getIncidentTypeLabel } from './helpers';

const headerStyle = {
  color: theme.colors.light_text,
  opacity: 0.6,
  fontSize: 10,
  cursor: 'pointer'
};

// staff-keyed incidents carry addedBy (stamped by rater-helpers addIncidents);
// everything else came in through vendor report pulls
const getSourceLabel = (incident, isAutoPolicy) => {
  if (incident.addedBy) {
    return `Manual (${incident.addedBy})`;
  }
  return isAutoPolicy ? incident.source : 'Reports';
};

export const IncidentTableHeader = ({ isAutoPolicy, classes, onSort, canScrub }) => {
  return (
    <>
      {canScrub && (
        <TableCell style={headerStyle} className={classes.tableHeader}>
          SELECT TO REMOVE
        </TableCell>
      )}
      <TableHeaderCell key={'date'} columnId={'date'} onSort={onSort} className={classes.tableSortLabelRoot}>
        Date
      </TableHeaderCell>
      {isAutoPolicy && <TableCell style={headerStyle}>DRIVER</TableCell>}
      <TableCell style={headerStyle}>TYPE</TableCell>
      <TableCell style={headerStyle}>CATEGORY</TableCell>
      <TableCell style={headerStyle}>SOURCE</TableCell>
    </>
  );
};

IncidentTableHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  isAutoPolicy: PropTypes.bool.isRequired,
  onSort: PropTypes.func.isRequired,
  canScrub: PropTypes.bool.isRequired
};

const IncidentTableRows = ({ incidents, classes, isAutoPolicy, onSelect, selectedIncidents, canScrub }) => {
  return (
    <>
      {incidents.map((incident, index) => (
        <TableRow key={index} hover classes={MapClassesToElem(`dark-${ElemType.TableRow}`, classes)}>
          {canScrub && (
            <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>
              <Checkbox
                mode="dark"
                id={`checkbox-${index}`}
                label=""
                onChange={({ target: { checked } }) => onSelect(incident, checked)}
                value={incident.id in selectedIncidents}
              />
            </TableCell>
          )}
          <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>
            {dateFormatter(incident.date)}
          </TableCell>
          {isAutoPolicy && (
            <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>{incident.driver}</TableCell>
          )}
          <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>
            {getIncidentTypeLabel(incident.type)}
          </TableCell>
          <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>
            {incident.category === 'claim' ? 'Claim' : 'Violation'}
          </TableCell>
          <TableCell classes={MapClassesToElem(`dark-${ElemType.TableCell}`, classes)}>
            {getSourceLabel(incident, isAutoPolicy)}
            {incident.isCourtRecord ? ' (Court Record)' : ''}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

IncidentTableRows.propTypes = {
  classes: PropTypes.object.isRequired,
  incidents: PropTypes.array.isRequired,
  selectedIncidents: PropTypes.object,
  isAutoPolicy: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
  canScrub: PropTypes.bool.isRequired
};

IncidentTableRows.defaultProps = {
  selectedIncidents: {},
  onSelect: () => {}
};

export default IncidentTableRows;
